module.exports = __webpack_public_path__ + "img/rammy-jam.10c7da47.png";